import React, {Component} from 'react'
import Meta from "../Meta";
import Header from "../components/Header";
import EventPageV2 from "./EventPageV2";
import EventMultiSession from "./EventMultiSession";
import Footer from "../components/Footer";
import {applyLang} from "../../../i18n";
import Loader from "../loader";
import {t} from "@lingui/core/macro"
import {fetchEvents} from "../../../services/EventService";

export default class Events extends Component{
    // Événements fetchés CÔTÉ CLIENT via /v1/events (modèle galeries/actualités).
    state = { events: [], loading: true };

    componentDidMount() {
        const org = this.props.context?.org;
        if (org) fetchEvents(org.id, {virtualId: org.virtualId || null}).then(d => this.setState({ events: d.events, loading: false }));
        else this.setState({ loading: false });
    }

    render(){
        const context=this.props.context
        const {org,config}=context
        const events = this.state.events;
        // L'événement (affiche ou PE) est résolu dans context.events (route /v1/events).
        const eventKey = context.page?.eventId || context.route[1]
        const rawEvent = (events || []).find(i=>i.id===eventKey)
        const event = rawEvent ? applyLang(rawEvent, context.lang) : null

        // Métadonnées : l'événement est fetché CÔTÉ CLIENT, donc absent au 1er
        // rendu (SSR). `page.meta` (posé par l'API pour les pages à URL
        // personnalisée) sert de repli pour que le titre et l'aperçu de lien ne
        // soient jamais vides pour un crawler.
        // 2 sources de repli SSR : `page.meta` (page à URL personnalisée) et
        // `data[0].meta` (préfetch de la route /evenement/<uuid>).
        const pageMeta = context.page?.meta || context.data?.[0]?.meta || {}
        const title=event?.name || pageMeta.title
        const description=event?.description || pageMeta.description
        const metaImage=event?.image || pageMeta.image
        const isMultiSession = !!event?.isMultiSession


        if(this.props.loading || this.state.loading){
            return (
                <div className="travel-page travel-page--home">
                    <Meta context={context} title={title} description={description} image={metaImage}/>
                    <Loader/>
                </div>
            )
        }

        return(
            <div className="travel-page travel-page--home">
                <Meta context={context} title={title} description={description} image={metaImage}/>
                <Header context={context}/>
                <div style={{marginTop: 20,minHeight:"50vh"}}>
                    {isMultiSession
                        ? <EventMultiSession context={context}/>
                        : <EventPageV2 context={context}/>
                    }
                </div>
                <Footer context={context}/>
            </div>
        )
    }
}
